module.exports = __webpack_public_path__ + "img/bg1.869e9ff7.jpg";